<template>
  <div class="h-screen flex w-full vx-row no-gutter justify-center items-center">
    <auth-logo-banner class="absolute top-0 w-full" />

    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-2/5 m-4">
      <vx-card v-if="verificationCompleted">
        <div class="flex vx-card__title mb-6 justify-center items-center col-gap-1">
          <h2 class="text-center">
            {{ title }}
          </h2>

          <feather-icon
            :icon="icon"
            :svgClasses="`h-6 w-6 text-${iconColor}`"/>
        </div>

        <vs-divider position="center">
        </vs-divider>

        <div class="subscription text-center">

          <span>
            {{ msg }}
          </span>

          <vs-button
            v-if="!verificationError"
            class="w-full mt-4"
            @click="onActionButton">
            {{ buttonText }}
          </vs-button>
        </div>
      </vx-card>
      <vx-card v-else>
        <div class="vx-card__title">
          <h2 class="text-center">
            {{ $t('VerifyingYorEmailMsg') }}
          </h2>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import AuthLogoBanner from '@/views/pages/auth/components/AuthLogoBanner.vue';

/**
 * @module views/pages/auth/TheAuthEmailVerification
 * @author Dilan Useche <dilan8810@gmail.com>
 */
export default {
  name: 'TheAuthEmailVerification',
  components: {
    AuthLogoBanner,
  },
  i18n: {
    messages: {
      en: {
        GoToDashboard: 'Go to dashboard',
        ResendVerificationEmail: 'Resend verification email',
        SuccessVerificationEmailNotificationTitle: 'Success email verification',
        SuccessVerificationEmailNotificationMsg: 'Your email {email} was successfully verified and you can now use it with your account.',
        ErrorVerificationEmailNotificationTitle: 'Unsuccess email verification',
        ErrorVerificationEmailNotificationMsg: 'Your email {email} could not be verified: {error}.',
        UnexpectedError: 'An unexpected error has occurred',
        VerifyingYorEmailMsg: 'Verifying your email...',
      },
    },
  },
  data() {
    return {
      email: '',
      verificationToken: '',
      verificationError: '',
      verificationCompleted: false,
    };
  },
  computed: {
    ...mapGetters({
      isUserLoggedIn: 'auth/isUserLoggedIn',
    }),
    title() {
      return this.verificationError
        ? this.$t('ErrorVerificationEmailNotificationTitle')
        : this.$t('SuccessVerificationEmailNotificationTitle');
    },
    msg() {
      return this.verificationError
        ? this.$t('ErrorVerificationEmailNotificationMsg', {
          email: this.email,
          error: this.verificationError,
        })
        : this.$t('SuccessVerificationEmailNotificationMsg', {
          email: this.email,
        });
    },
    icon() {
      return this.verificationError
        ? 'XCircleIcon'
        : 'CheckCircleIcon';
    },
    iconColor() {
      return this.verificationError
        ? 'danger'
        : 'success';
    },
    buttonText() {
      if (this.verificationError) {
        return this.$t('ResendVerificationEmail');
      }

      return this.isUserLoggedIn
        ? this.$t('GoToDashboard')
        : this.$t('$Auth.Login');
    },
  },
  created() {
    this.email = this.$route.params.email;
    this.verificationToken = this.$route.params.verificationToken;

    if (!this.email || !this.verificationToken) {
      this.$router.push({ name: 'not-authorized' }).catch(() => {});
    }

    this.verifyEmail();
  },
  methods: {
    ...mapActions({
      verifyEmailByLink: 'auth/verifyEmailByLink',
    }),
    async verifyEmail() {
      this.$vs.loading({ type: 'radius' });

      try {
        await this.verifyEmailByLink({
          email: this.email,
          token: this.verificationToken,
        });
      } catch (err) {
        console.log(err);
        if (err.response && err.response.data && err.response.data.message) {
          this.verificationError = err.response.data.message;
        } else {
          this.verificationError = this.$t('UnexpectedError');
        }
      } finally {
        this.$vs.loading.close();
        this.verificationCompleted = true;
      }
    },
    async onActionButton() {
      if (this.isUserLoggedIn) {
        this.$router.push({ name: 'home' }).catch(() => {});
      } else {
        this.$router.push({ name: 'login' }).catch(() => {});
      }
    },
  },
};
</script>
